module.exports = __webpack_public_path__ + "static/img/automan_1.ae2c8fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/automan_1.png
// module id = 3fhB
// module chunks = 1